import React, { useEffect, useState } from "react";
import "./notifications.css";
import { getNotifications, updateConnectionStatus } from "../../../services/connectionAPI.ts";
import { Avatar } from "@mui/material";

const Notifications = () => {
  const [requests, setRequests] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const loadNotifications = async () => {
    setLoading(true);
    try {
      const res = await getNotifications();
      setRequests(res.requests || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadNotifications();
  }, []);

  const handleAction = async (requestId: number, status: "accepted" | "rejected") => {
    try {
      await updateConnectionStatus(requestId, status);
      await loadNotifications();
    } catch (err) {
      console.error(err);
    }
  };

  const getInitial = (name?: string) => (name ? name.charAt(0).toUpperCase() : "?");

  return (
    <div className='notif-root'>
      <div className='notif-header'>
        <h2>Connection Requests</h2>
        <p>Manage your interests and respond to requests</p>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : requests.length === 0 ? (
        <div className='empty-state'>
          <p>No connection requests yet 💔</p>
        </div>
      ) : (
        <div className='notif-list'>
          {requests.map((req) => (
            <div key={req.id} className='notif-card'>
              {/* LEFT */}
              <div className='notif-left'>
                <Avatar className='notif-avatar'>{getInitial(req.name)}</Avatar>

                <div>
                  <h3>{req.name}</h3>
                  <p className='meta'>
                    {req.gender} • {req.resident_country}
                  </p>
                </div>
              </div>

              {/* RIGHT */}
              <div className='notif-right'>
                <span className='status pending'>Pending</span>

                <div className='action-btns'>
                  <button className='accept-btn' onClick={() => handleAction(req.id, "accepted")}>
                    Accept
                  </button>

                  <button className='reject-btn' onClick={() => handleAction(req.id, "rejected")}>
                    Reject
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Notifications;
